import MainCard from 'ui-component/cards/MainCard';
import ProvidersList from './components/ProvidersList';
import { useEffect, useState } from 'react';
import ProviderFirestoreService from './services/ProvidersService';
import FirebaseStorageService from 'firebaseService/firebaseStorage';
import { Box, Grid, LinearProgress, Typography } from '@mui/material';
import LoaderSpinner from 'ui-component/LoaderSpinner';
import BallotIcon from '@mui/icons-material/Ballot';

const ProvidersListView = () => {
  const [providers, setProviders] = useState([]);
  const [isLoading, setLoading] = useState(false);
  const [loader, setLoader] = useState(false);

  const columnsExtra = [
    { field: 'website', headerName: 'Website', flex: 2.2, minWidth: 200 },
    { field: 'tag', headerName: 'Tag', flex: 2.2, minWidth: 200 }
  ];
  useEffect(() => {
    setLoading(true);
    setLoader(true);
    const handleResources = async (data, setDataFunction) => {
      const icons = await Promise.all(data.map((resource) => resource.iconSrc && FirebaseStorageService.downloadFile(resource.iconSrc)));
      data.forEach((resource, index) => (resource.icon = icons[index]));

      setDataFunction(data);
      setLoading(false);
      setLoader(false);
    };

    const unsubscribeProviders = ProviderFirestoreService.subscribeToResourcesProvider((data) => handleResources(data, setProviders));

    return () => {
      unsubscribeProviders();
    };
  }, []);

  return (
    <div style={{ marginTop: '20px' }}>
      <MainCard
        title={
          <Grid container justifyContent={'center'} alignItems={'center'}>
            <Grid item xs={12}>
              <Typography variant="h1" component="h2">
                Lista de Proveedores
              </Typography>
              <Typography variant="h4">Valida los proveedores de servicios disponibles</Typography>
            </Grid>
          </Grid>
        }
        secondary={
          <Grid container justifyContent={'center'}>
            <Box>
              <BallotIcon style={{ width: 60, height: 60 }} />
            </Box>
          </Grid>
        }
      >
        <Box sx={{ width: '100%' }}>{isLoading && <LinearProgress />}</Box>
        <ProvidersList rows={providers} columnsExtra={columnsExtra} />
        <LoaderSpinner isOpen={loader} setIsOpen={setLoader} />
      </MainCard>
    </div>
  );
};

export default ProvidersListView;
